import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  static outlets = ["fonts--site-font"];

  connect() {
    this.#toggleHeadingStyle();
  }

  changeHeadingFont() {
    const selectedHeadingFontOption = this.fontsSiteFontOutlet.headingFontTarget.querySelector("option:checked");
    const hasBoldWeight = selectedHeadingFontOption.dataset.headingBold === "true";
    let weightOptions = `<option value="Normal">Normal</option>`;

    if (hasBoldWeight) {
      weightOptions += `<option value="Bold">Bold</option>`
    }

    this.fontsSiteFontOutlet.headingFontWeightTarget.innerHTML = weightOptions
    this.fontsSiteFontOutlet.cacheCustomFontPreview("headingFontId", this.fontsSiteFontOutlet.headingFontTarget.value);

    // Load google font for custom heading
    const fontHeadingName = selectedHeadingFontOption.dataset.familyName;
    if (fontHeadingName) {
      this.fontsSiteFontOutlet.loadGoogleFonts([fontHeadingName]);
    }

    this.#toggleHeadingStyle();
  }

  changeHeadingFontWeight() {
    this.fontsSiteFontOutlet.cacheCustomFontPreview("headingFontId", this.fontsSiteFontOutlet.headingFontTarget.value);
    this.fontsSiteFontOutlet.cacheCustomFontPreview("headingFontWeightStyle", this.fontsSiteFontOutlet.headingFontWeightTarget.value);
  }

  changeHeadingFontCase() {
    this.fontsSiteFontOutlet.cacheCustomFontPreview("headingFontId", this.fontsSiteFontOutlet.headingFontTarget.value);
    this.fontsSiteFontOutlet.cacheCustomFontPreview("headingFontCaseStyle", this.fontsSiteFontOutlet.headingFontCaseTarget.value || 'inherit');
  }

  changeBodyFont() {
    this.fontsSiteFontOutlet.cacheCustomFontPreview("bodyFontId", this.fontsSiteFontOutlet.bodyFontTarget.value);

    // Load google font for custom body
    const selectedBodyFontOption = this.fontsSiteFontOutlet.bodyFontTarget.querySelector("option:checked");
    const fontBodyName = selectedBodyFontOption.dataset.familyName;
    if (fontBodyName) {
      this.fontsSiteFontOutlet.loadGoogleFonts([fontBodyName]);
    }
  }

  clearSelections() {
    this.fontsSiteFontOutlet.bustAppearancePreviewCache(app.sidebar.dirty);
    this.fontsSiteFontOutlet.showPreviewActionBtns();
    this.fontsSiteFontOutlet.headingStyleTarget.classList.add('hidden');
    this.fontsSiteFontOutlet.hiddenFontPairingIdTarget.value = $('#persistent_font_pairing_id').val();
  }

  #toggleHeadingStyle() {
    const headingFontValue = this.fontsSiteFontOutlet.headingFontTarget.value;

    if (headingFontValue === '') {
      this.fontsSiteFontOutlet.headingStyleTarget.classList.add('hidden');
    } else {
      this.fontsSiteFontOutlet.headingStyleTarget.classList.remove('hidden');
    }
  }
}
